import React from 'react';
import { Separator } from '@/components/ui/separator';
import MetricsOverview from '@/components/business/MetricsOverview';
import LeadList from '@/components/business/leads/LeadList';
import MobileTimeFrameSection from './MobileTimeFrameSection';
import { TimeFrameOption } from '@/components/business/leads/utils/dateFilters';
import { Lead, LeadStatus, LeadOutcome } from '@/components/business/leads/types/LeadTypes';
import { useIsMobile } from '@/hooks/use-mobile';

interface BusinessContentProps {
  businessId: string;
  leads: Lead[];
  timeFrame: TimeFrameOption;
  onTimeFrameChange: (value: TimeFrameOption) => void;
  searchTerm: string;
  onSearch: (term: string) => void;
  onStatusChange: (id: string, status: LeadStatus) => void;
  onOutcomeChange: (id: string, outcome: LeadOutcome | null) => void;
  onValueChange: (id: string, value: string) => void;
  onNameChange: (id: string, name: string) => void;
  metricsRefreshKey: number;
  onEditCampaign?: () => void;
}

const BusinessContent: React.FC<BusinessContentProps> = ({
  businessId,
  leads,
  timeFrame,
  onTimeFrameChange,
  searchTerm,
  onSearch,
  onStatusChange,
  onOutcomeChange,
  onValueChange,
  onNameChange,
  metricsRefreshKey,
  onEditCampaign
}) => {
  const isMobile = useIsMobile();
  
  return (
    <main className="flex-1 max-w-screen-xl mx-auto px-0 md:px-0 py-4 md:py-8 w-full animate-fade-in bg-brand-light">
      {isMobile && (
        <MobileTimeFrameSection 
          timeFrame={timeFrame} 
          onTimeFrameChange={onTimeFrameChange} 
        />
      )}
      
      <div className="mb-6 px-4 md:px-6">
        <MetricsOverview 
          businessId={businessId} 
          leads={leads} 
          timeFrame={timeFrame}
          key={`metrics-${metricsRefreshKey}`}
        />
      </div>
      
      <div className="px-4 md:px-6">
        <Separator className={isMobile ? "mt-2 mb-3" : "my-6"} />
      </div>
      
      <div className="w-full px-0">
        <LeadList 
          leads={leads}
          onStatusChange={onStatusChange} 
          onOutcomeChange={onOutcomeChange} 
          onValueChange={onValueChange} 
          onNameChange={onNameChange}
          onSearch={onSearch}
          searchTerm={searchTerm}
        />
      </div>
    </main>
  );
};

export default BusinessContent;
